import { useLanguage } from "../../../../../stores/LanguageStore";
import { Group, Paper, Text, Tooltip } from "@mantine/core";
import { types } from "./jobTypes";
import { parseDate } from "../../../../../functions/dates";
import { Link } from "react-router-dom";
import { handleJobItem } from "./JobItemArguments";
import { useListStore } from "../../../../../stores/ListStore";
import { useEffect, useMemo } from "react";
import { getPermission } from "../../../../../functions/utilFunctions";
import DeleteJob from "./DeleteJob";
import { useSessionStore } from "../../../../../stores/UserStore";
import { getLinkedinAccounts } from "../../../../../api/EmailAPI";

const JobItemFailed = ({ item, setFailed }) => {
  const lang = useLanguage((s) => s.language);
  const reseller = useSessionStore((s) => s.reseller);
  const startDate = item.start_date
    ? new Date(Date.parse(item.start_date))
    : null;
  const endDate = item?.end_date ? new Date(Date.parse(item.end_date)) : null;
  const queuedDate = item?.queued_date
    ? new Date(Date.parse(item.queued_date))
    : null;

  const getText = () => {
    let m = item?.error?.toString() || "";
    if (
      m === `{"state":false,"state_message":"need_sales_navigator_account"}`
    ) {
      return (
        <Text>
          Un compte sales navigator est nécessaire pour cet import. <br />
          <br />
          SI votre compte est bien sales navigator mais que notre système ne l'a
          pas encore détécté, vous pouvez ouvrir une page sales navigator puis
          cliquer sur notre extension.
          <br />
          <br />
          Ensuite, vous pouvez relancer votre import
        </Text>
      );
    }
    if (m === `{"state":false,"state_message":"unexpected_exception"}`) {
      return lang.contact_lists.jobs.error.unknown_error;
    }
    if (m === `Length of search URL too long`) {
      return lang.contact_lists.jobs.error.too_long_criteria;
    }
    if (
      m === `{"state":false,"state_message":"need_sales_navigator_account"}`
    ) {
      return (
        <Text size="md">
          {lang.errors.main.no_more_enrich}{" "}
          {/* {getPermission("displayPricing") && ( */}
          <Link
            style={{
              marginLeft: 4,
              fontWeight: 600,
              color: "var(--mantine-color-primary-6)",
              fontSize: 15,
            }}
            to={"/settings/subscription"}
          >
            {lang.global.here}
          </Link>
          {/* )} */}
        </Text>
      );
    }
    if (m.includes("_per_month_reached")) {
      return (
        <Text size="md">
          {getPermission("displayPricing")
            ? lang.errors.main.no_more_enrich
            : lang.errors.main.no_more_enrich.split(",")[0]}{" "}
          {getPermission("displayPricing") && (
            <Link
              style={{
                marginLeft: 4,
                fontWeight: 600,
                color: "var(--mantine-color-primary-6)",
                fontSize: 15,
              }}
              to={"/settings/subscription"}
            >
              {lang.global.here}
            </Link>
          )}
        </Text>
      );
    }
    if (
      m ===
      `{"state":false,"state_message":"require_valid_linkedin_integration_or_subscription"}`
    ) {
      return (
        <Text size="md">
          {lang.errors.main.require_valid_linkedin_integration_or_subscription}{" "}
          {getPermission("displayPricing") && (
            <Link
              style={{
                marginLeft: 4,
                fontWeight: 600,
                color: "var(--mantine-color-primary-6)",
                fontSize: 15,
              }}
              to={"/settings/subscription"}
            >
              {lang.global.here}
            </Link>
          )}
        </Text>
      );
    }

    if (m?.includes("errors")) {
      let errors = JSON.parse(item.error)?.errors;
      if (errors)
        return (
          <ul>
            {errors.map((x, i) => (
              <li key={i} style={{ listStyle: "none", fontStyle: "normal" }}>
                <b>line {x.line}</b> : {x.error}
              </li>
            ))}
          </ul>
        );
    }
    return item?.error;
  };

  const lists = useListStore((s) => s.lists);
  const fromLists = useMemo(() => {
    if (item.type === "Merge") {
      return item.arguments.contactListIds.map((id) => {
        return lists?.find((x) => x.id === id) || { id };
      });
    }
    if (item.arguments?.fromContactListId) {
      let sourceList = lists?.find(
        (x) => x.id === item.arguments.fromContactListId
      );
      return sourceList
        ? [sourceList]
        : [
          {
            id: item.arguments.fromContactListId,
          },
        ];
    }
    if (item.arguments?.sourceContactListId) {
      let sourceList = lists?.find(
        (x) => x.id === item.arguments.sourceContactListId
      );
      return sourceList
        ? [sourceList]
        : [
          {
            id: item.arguments.sourceContactListId,
          },
        ];
    }
    return null;
  }, [lists, item]);

  const onJobDeleted = () => {
    setFailed((prev) => {
      return prev.filter((x) => x.uniqid !== item.uniqid);
    });
  };

  useEffect(() => {
    if (reseller?.name === "Magileads") {
      setTimeout(() => {
        document.querySelector(".woot-widget-bubble")?.click();
      }, 2000);
    }
  }, [reseller]);

  return (
    <Paper withBorder p={"sm"} bg={"#00000006"}>
      <Group>
        <Group direction="row" gap={4} mr={1}>
          {types(item.type)?.icon}

          <Text fw={500} fz={14}>
            {types(item.type, false, item?.arguments?.generateEmail)?.label}
          </Text>
        </Group>
        <Text fz={10} style={{ opacity: 0.75 }}>
          {queuedDate && (
            <>
              <b>{lang.contact_lists.jobs.queued_date}</b>{" "}
              <Tooltip label={queuedDate.toLocaleString()}>
                <span style={{ marginRight: 8 }}>{parseDate(queuedDate)}</span>
              </Tooltip>
            </>
          )}
          <b>{lang.contact_lists.jobs.start_date}</b>{" "}
          <Tooltip label={startDate?.toLocaleString()}>
            <span style={{ marginRight: 8 }}>
              {startDate ? parseDate(startDate) : " - "}
            </span>
          </Tooltip>
          {endDate && (
            <>
              <b>{lang.contact_lists.jobs.end_date}</b>{" "}
              <Tooltip label={endDate.toLocaleString()}>
                <span>{parseDate(endDate)}</span>
              </Tooltip>
            </>
          )}{" "}
        </Text>

        <DeleteJob id={item.uniqid} onFinish={onJobDeleted} />
      </Group>
      <Text size="sm" c={"#c00"} fs={"italic"} mt={6}>
        {getText()}
      </Text>
      {handleJobItem({ item: item, fromLists, isProgress: true })}
    </Paper>
  );
};

export default JobItemFailed;
